import type {ReactNode} from 'react';
import {cn} from '@chekinapp/ui';

type Props = {
  children: ReactNode;
  className?: string;
};

function SheetActions({children, className}: Props) {
  return (
    <div className={cn('mx-auto flex w-full max-w-[375px] flex-col gap-5', className)}>
      {children}
    </div>
  );
}

export {SheetActions};
